export enum Operator {
    Zain = 1,
    STC = 2,
    Mobily = 3,
}
